<template>
<div class="container py-4">
      <header class=" mb-4">
        <h1 class="mb-4 border-bottom pb-2">Playlist manager</h1> <br>
 <h6>In this section, you can add or delete a user's playlist. For details, see the Playlist Instructions.</h6>


      
      </header>
      <div class="upload-container">
        <h2>Add playlist</h2>
    
        <form @submit.prevent="submitForm">
          <div class="input-container">
            <label for="androidId">Device ID</label>
            <input 
              type="text" 
              id="androidId" 
              v-model="androidId" 
              placeholder="Enter Device ID" 
              required 
            />
          </div>
          <div class="input-container">
            <label for="m3u8Url">Playlist URL</label>
            <input 
              type="url" 
              id="m3u8Url" 
              v-model="m3u8Url" 
              placeholder="Enter M3U8 URL" 
              required 
            />
          </div>
          <div class="input-container">
            <label for="name">Playlist Name</label>
            <input 
              type="text" 
              id="name" 
              v-model="name" 
              placeholder="Enter Playlist Name" 
              required 
            />
          </div>
          <div class="input-container">
            <label for="epgUrl">EPG URL (optional)</label>
            <input 
              type="url" 
              id="epgUrl" 
              v-model="epgUrl" 
              placeholder="Enter EPG URL (optional)" 
            />
          </div>
          <div class="input-container">
            <label for="vodUrl">VOD URL (optional)</label>
            <input 
              type="url" 
              id="vodUrl" 
              v-model="vodUrl" 
              placeholder="Enter VOD URL (optional)" 
            />
          </div>
          <div class="input-container">
            <label for="vodUrl">Radio URL (optional)</label>
            <input 
              type="url" 
              id="radiourl" 
              v-model="radioUrl" 
              placeholder="Enter Radio URL (optional)" 
            />
          </div>
       
          <div
  class="g-recaptcha"
  id="recaptcha-upload"
  data-sitekey="6Lfx7SMsAAAAALgdKWlSs9-StRgUfvKXZ-FvEch_"
  data-callback="onCaptchaUploadVerified">
</div>
          <button type="submit" :disabled="isSubmitting ">Upload</button>
          <div v-if="isSubmitting">Processing...</div>
          <div v-if="statusMessage" class="status-message">{{ statusMessage }}</div>
        </form>
  
        <h2 style="padding-top:100px">Delete playlist</h2>
        <form @submit.prevent="deleteForm">
          <div class="input-container">
            <label for="deleteAndroidId">Device ID</label>
            <input 
              type="text" 
              id="deleteAndroidId" 
              v-model="deleteAndroidId" 
              placeholder="Enter Device ID" 
              required 
            />
          </div>
          <div class="input-container">
            <label for="deleteName">Playlist Name</label>
            <input 
              type="text" 
              id="deleteName" 
              v-model="deleteName" 
              placeholder="Enter Playlist Name" 
              required 
            />
          </div>
        

          <div
  class="g-recaptcha"
  id="recaptcha-delete"
  data-sitekey="6Lfx7SMsAAAAALgdKWlSs9-StRgUfvKXZ-FvEch_"
  data-callback="onCaptchaDeleteVerified">
</div>
          <button type="submit" :disabled="isSubmitting ">Delete</button>

          <div v-if="isSubmitting">Processing...</div>
          <div v-if="statusMessageDelete" class="status-message">{{ statusMessageDelete }}</div>
        </form>
      </div>
    </div>
    
  </template>
  
  <script>
 import axios from 'axios';

export default {
  data() {
    return {
        captchaInitialized: false,
        isCaptchaUploadVerified: false,
isCaptchaDeleteVerified: false,

      androidId: '',
      m3u8Url: '',
      epgUrl: '',
      vodUrl: '',
      radioUrl: '', // Dodato za Radio URL
      name: '',
      operater: '',
      deleteAndroidId: '',
      deleteName: '',
      securityCode: '', // za dodavanje
deleteSecurityCode: '', // za brisanje

      isSubmitting: false,
      captchaCheckInterval:null,
      isCaptchaVerified: false, // CAPTCHA mora biti potvrđena pre slanja
      statusMessage: '',// Poruka za dodavanje playliste
      statusMessageDelete: '', // Poruka za brisanje playliste // Nova promenljiva za statusnu poruku
    };
  },
  mounted(){
    const checkReady = () => {
    if (window.grecaptcha && window.grecaptcha.render) {
      this.initCaptchas(); // kad je spreman
    } else {
      setTimeout(checkReady, 500); // čekaj dok se ne učita
    }
  };
  checkReady();
   
  },
  beforeUnmount() {
  if (typeof window.grecaptcha?.reset === 'function') {
  
      window.grecaptcha.reset(this.widgetUpload);
      window.grecaptcha.reset(this.widgetDelete);
  
  }
  this.widgetUpload = null;
  this.widgetDelete = null;
  this.isCaptchaUploadVerified = false;
  this.isCaptchaDeleteVerified = false;
},

  methods: {
    initCaptchas() {
  // sprečava višestruko renderovanje
  if (!this.widgetUpload) {
    this.widgetUpload = window.grecaptcha.render('recaptcha-upload', {
      sitekey: '6Lfx7SMsAAAAALgdKWlSs9-StRgUfvKXZ-FvEch_',
      callback: () => {
        this.isCaptchaUploadVerified = true;
      },
      'expired-callback': () => {
        this.isCaptchaUploadVerified = false;
      }
    });
  }

  if (!this.widgetDelete) {
    this.widgetDelete = window.grecaptcha.render('recaptcha-delete', {
      sitekey: '6Lfx7SMsAAAAALgdKWlSs9-StRgUfvKXZ-FvEch_',
      callback: () => {
        this.isCaptchaDeleteVerified = true;
      },
      'expired-callback': () => {
        this.isCaptchaDeleteVerified = false;
      }
    });
  }
}
,
    async submitForm() {
  this.isSubmitting = true;
  this.statusMessage = '';

  if (!this.isCaptchaUploadVerified) {
    this.statusMessage = "Please complete the CAPTCHA!";
    this.isSubmitting = false;
    return;
  }
  const captchaResponse = window.grecaptcha.getResponse(this.widgetUpload);
  // sada znamo da postoji
  const userData = JSON.parse(localStorage.getItem("userData"));
  const adminToken = localStorage.getItem("adminToken");

  const payload = {
    deviceId: this.androidId,
    m3uUrl: this.m3u8Url,
    epg_url: this.epgUrl || null,
    name: this.name,
    vod_url: this.vodUrl || null,
    radio: this.radioUrl || null,
    operater_id: userData?.ident || null,
    recaptchaToken: captchaResponse,
  

  };

  try {
    const response = await axios.post(
      'https://app.streamboxtv.live/api3002/upload-m3u-operator',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${adminToken}`,
        },
      }
    );

    this.statusMessage = 'Playlist successfully uploaded!';
    console.log(response.data);
window.grecaptcha.reset(this.widgetUpload);

    this.isCaptchaUploadVerified = false; // resetuje flag
  } catch (error) {
    console.error('Error uploading M3U8 URL:', error.response || error.message);
    this.statusMessage =
      error.response?.data?.message || 'Unknown error occurred during upload.';
  } finally {
    this.isSubmitting = false;
  }
}
,async deleteForm() {
  if (!this.isCaptchaDeleteVerified) {
    this.statusMessageDelete = 'Please complete the CAPTCHA before deleting.';
    return;
  }

  this.isSubmitting = true;
  this.statusMessageDelete = '';

  const captchaResponse = window.grecaptcha.getResponse(this.widgetDelete);

  const userData = JSON.parse(localStorage.getItem("userData")); // 👈 dohvatamo ident

const payload = {
  deviceId: this.deleteAndroidId,
  name: this.deleteName,
  recaptchaToken: captchaResponse,

  ident: userData?.ident || null // 👈 dodajemo ident
};


  try {
    const response = await axios.delete(
      'https://app.streamboxtv.live/api3002/api/delete-m3u-url-secure',
      { params: payload }
    );

    this.statusMessageDelete = response.data.message || 'Playlist deleted successfully!';
    console.log(response.data);

    // Reset CAPTCHA
    window.grecaptcha.reset(this.widgetDelete);
    this.isCaptchaDeleteVerified = false;

    // Reset input polja
    this.deleteAndroidId = '';
    this.deleteName = '';
    this.deleteSecurityCode = '';
  } catch (error) {
    console.error('Error deleting playlist:', error.response || error.message);
    this.statusMessageDelete =
      error.response?.data?.message || 'Unknown error occurred during deletion.';
  } finally {
    this.isSubmitting = false;
  }
}




  },
};

  </script>
  
  <style scoped>
  p {
    color: white;

    margin-bottom: 30px;
  }
  .upload-container {
    background-color: #0f0f0f; /* Tamno siva pozadina */
    color: white; /* Bele labele i tekst */
    padding: 30px 40px;
    border-radius: 10px; /* Zaobljeni uglovi */
    width: 100%; /* Širina komponente */

    text-align: center; /* Centriranje sadržaja */

    border: 2px solid #0099ff;
  }
  
  h2 {
    font-weight: 500;
   
    color: #0099ff;
    margin-bottom: 20px;
  }
  
  form {
    margin-bottom: 20px;
  }
  
  .input-container {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
    color: white;
    font-weight: bold;
    text-align: left;
  }
  
  input[type='url'],
  input[type='text'] {
    width: 100%;
    padding: 10px;
    border: 1px solid #4b4b4b;
    border-radius: 5px;
    font-size: 14px;
    box-sizing: border-box;
    background-color: #202020;
    color: white;
  }
  
  button {
    width: 100%;
    padding: 10px;
    background-color: #0099ff;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  button:hover {
    background-color: #00aeff;
  }
  
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  div[v-if] {
    margin-top: 15px;
    font-size: 14px;
  }
  
  #upload-container {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 40px 0;
    padding-top: 10px;
  }
  button {
    margin-top: 50px;
  }
  .status-message {
    margin-top: 10px;
    font-size: 16px;
    color: #00ff00; /* Zeleno za uspeh */
  }
  
  .status-message.error {
    color: #ff0000; /* Crveno za greške */
  }
  #recaptcha{
 
    transform:scale(0.8) translateX(-50px);
 
  }
  header{
    color:white;
  }
  .mb-4 {
  margin-top: 20px;
}
h6{
    color:silver;
}
  </style>
  